import type { QueryClient } from '@tanstack/react-query';

import { getClassroomTeachersQueryKey } from '../hooks/use-classroom-teachers';
import type { ClassroomTeacher } from '../modules/teacher';

type Props = {
  classroomId: string;
  isPlatformEnabled: boolean;
  organizationId: string;
  queryClient: QueryClient;
  teacherId: string;
};

function updateTeachersInCache({
  classroomId,
  isPlatformEnabled,
  organizationId,
  queryClient,
  teacherId,
}: Props): void {
  const key = getClassroomTeachersQueryKey({
    classroomId,
    isPlatformEnabled,
    organizationId,
  });
  const teachersQuery = queryClient.getQueryData<{
    teachers?: Array<ClassroomTeacher | null> | null;
  }>(key);

  if (teachersQuery) {
    queryClient.setQueryData(key, {
      teachers: teachersQuery.teachers?.map((teacher) =>
        teacher?.id === teacherId
          ? { ...teacher, reportsEnabled: !teacher?.reportsEnabled }
          : teacher
      ),
    });
  }
}

export { updateTeachersInCache };
